export const limpiar = function limpiar (s) {
  if (s === '')
    return s
  let r = s.toLowerCase();
  r = r.replace(new RegExp(/\s/g)," ")
  r = r.replace(new RegExp(/[àáâãäå]/g),"a")
  r = r.replace(new RegExp(/æ/g),"ae")
  r = r.replace(new RegExp(/ç/g),"c")
  r = r.replace(new RegExp(/[èéêë]/g),"e")
  r = r.replace(new RegExp(/[ìíîï]/g),"i")
  r = r.replace(new RegExp(/ñ/g),"n")              
  r = r.replace(new RegExp(/[òóôõö]/g),"o")
  r = r.replace(new RegExp(/œ/g),"oe")
  r = r.replace(new RegExp(/[ùúûü]/g),"u")
  r = r.replace(new RegExp(/[ýÿ]/g),"y")
  r = r.replace(new RegExp(/\W/g),"")
  r = r.replace(new RegExp(/%/g),"_")
  // r = r.replace(new RegExp(/'/g),"_")
  return r
}

export const sinAcento = (s) => {
  if (s === '')
    return s
  s = s.replace(new RegExp(/[àáâãäå]/g),"a")
  s = s.replace(new RegExp(/[èéêë]/g),"e")
  s = s.replace(new RegExp(/[ìíîï]/g),"i")
  s = s.replace(new RegExp(/[ùúûü]/g),"u")
  s = s.replace(new RegExp(/[òóôõö]/g),"o")
  s = s.replace(new RegExp(/æ/g),"ae")
  s = s.replace(new RegExp(/œ/g),"oe")
  s = s.replace(new RegExp(/[ýÿ]/g),"y")
  s = s.toLowerCase()
  return s
}